import {PatientSubmissions} from 'src/app/models/patientSubmissions';

export interface Patient {
  id?: string;
  firstName: string;
  lastName: string;
  middleInitial: string;
  location: string;
  team: string;
  picture: string;
  branch: string;
  icdCodes: Object;
  payorSource: string[];
  referencingPhysician: string;
  admissionCoordinator: string;
  CEFSClaimBenefitPeriodDate: string[];
  CEFSClaimOrder: string[];
  pdf: string;
  contactInfo: object;
  verificationCode: string;
  mrn: string;
  agencies: {};
  userId: string;
  submissions?: PatientSubmissions[];
  totalErrors?: number;
  totalWarnings?: number;
  showSubmissionsDetails?: boolean;
  showEpisodeDetails?: boolean;
  CaseManagerFirstName?: string;
  CaseManagerLastName?: string;
}

export interface PatientInvoice {
  _id?: string;
  patientId: string;
  iDoc: string;
  deliveryStatus: string;
  activityDate: string;
  createdBy: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;
}

export const refreshTime = [
  { label: 'Refresh every 30 sec', value: '30' },
  { label: 'Refresh every 1 min', value: '60' },
  { label: 'Refresh every 5 min', value: '300' }
];

export const patientSubmissionDropdown = [
  { label: 'Episodes', value: 'episodes' },
  { label: 'Patients', value: 'p-visits' },
  { label: 'Visits', value: 'visits' },
  { label: 'Unmatched Visits', value: 'unmatched-visits' },
];

export const viewByVisitDropdown = [
  { label: 'Visits', value: 'visits' },
  { label: 'Unmatched Visits', value: 'unmatched-visits' },
];



export const submissionStatus = [
  { label: 'All', value: '' },
  { label: 'Started', value: 'in-progress' },
  { label: 'In Progress', value: 'incomplete'},
  { label: 'Completed', value: 'completed' },
  { label: 'Reviewed', value: 'reviewed' },
  { label: 'Not Addressed', value: 'not_addressed' },
  { label: 'Needs Correction', value: 'needs_correction' },
  { label: 'Recheck', value: 'recheck' },
  { label: 'Started', value: 'waiting_for_review' },
  { label: 'Late', value: 'late' },
];

export const submissionTypes = [
  { label: 'PT00', value: 'PT00'},
  { label: 'PT00P', value: 'PT00P'},
  { label: 'PT00PP', value: 'PT00PP'},
  { label: 'PT00X', value: 'PT00X'},
  { label: 'PT00XP', value: 'PT00XP'},
  { label: 'PT00Z', value: 'PT00Z'},
  { label: 'PT01', value: 'PT01'},
  { label: 'PT01H', value: 'PT01H'},
  { label: 'PT01P', value: 'PT01P'},
  { label: 'PT01PP', value: 'PT01PP'},
  { label: 'PT02', value: 'PT02'},
  { label: 'PT02PP', value: 'PT02PP'},
  { label: 'PT02XP', value: 'PT02XP'},
  { label: 'PT04', value: 'PT04'},
  { label: 'PT04NX', value: 'PT04NX'},
  { label: 'PT05', value: 'PT05'},
  { label: 'PT06', value: 'PT06'},
  { label: 'PT06P', value: 'PT06P'},
  { label: 'PT10', value: 'PT10'},
  { label: 'PT10N', value: 'PT10N'},
  { label: 'PT11', value: 'PT11'},
  { label: 'PT11-EXT', value: 'PT11-EXT'},
  { label: 'PT11-TELE', value: 'PT11-TELE'},
  { label: 'PT11-TELP', value: 'PT11-TELP'},
  { label: 'PT11H', value: 'PT11H'},
  { label: 'PT11M', value: 'PT11M'},
  { label: 'PT11N', value: 'PT11N'},
  { label: 'PT11N-TELE', value: 'PT11N-TELE'},
  { label: 'PT11N-TELP', value: 'PT11N-TELP'},
  { label: 'PT11P', value: 'PT11P'},
  { label: 'PT11PP', value: 'PT11PP'},
  { label: 'PT11R', value: 'PT11R'},
  { label: 'PT15', value: 'PT15'},
  { label: 'PT17', value: 'PT17'},
  { label: 'PT18', value: 'PT18'},
  { label: 'PT18P', value: 'PT18P'},
  { label: 'PT18X', value: 'PT18X'},
  { label: 'PT19', value: 'PT19'},
  { label: 'PT19N', value: 'PT19N'},
  { label: 'PT19P', value: 'PT19P'},
  { label: 'PT19PP', value: 'PT19PP'},
  { label: 'PT33', value: 'PT33'},
  { label: 'PT33M', value: 'PT33M'},
  { label: 'PT33P', value: 'PT33P'},
  { label: 'PT33PP', value: 'PT33PP'},
  { label: 'PT40NX', value: 'PT40NX'},
  { label: 'PT44', value: 'PT44'},
  { label: 'PT66', value: 'PT66'},
  { label: 'PT88', value: 'PT88'},
  { label: 'PT91', value: 'PT91'},
  { label: 'PT92', value: 'PT92'},
  { label: 'PT93', value: 'PT93'},
  { label: 'PT NO MOVE', value: 'PT NO MOVE'},
  { label: '2 HOUR RN', value: '2 HOUR RN'},
  { label: 'ADMN-SIGNP', value: 'ADMN-SIGNP'},
  { label: 'BC72H', value: 'BC72H'},
  { label: 'BC72HP', value: 'BC72HP'},
  { label: 'CAHPS', value: 'CAHPS'},
  { label: 'CH-LINK', value: 'CH-LINK'},
  { label: 'CH-NOMNC', value: 'CH-NOMNC'},
  { label: 'CH-POCH', value: 'CH-POCH'},
  { label: 'CH-PTEXPH', value: 'CH-PTEXPH'},
  { label: 'CH-VCH', value: 'CH-VCH'},
  { label: 'CH01H', value: 'CH01H'},
  { label: 'CH01HN-TEL', value: 'CH01HN-TEL'},
  { label: 'CH11H', value: 'CH11H'},
  { label: 'CH11HN-TEL', value: 'CH11HN-TEL'},
  { label: 'CH11HP', value: 'CH11HP'},
  { label: 'CH40H', value: 'CH40H'},
  { label: 'CH72H', value: 'CH72H'},
  { label: 'CH72HP', value: 'CH72HP'},
  { label: 'CHIH', value: 'CHIH'},
  { label: 'CHPRNH', value: 'CHPRNH'},
  { label: 'CLINIC-M', value: 'CLINIC-M'},
  { label: 'CLINIC-MP', value: 'CLINIC-MP'},
  { label: 'CLINIC-P', value: 'CLINIC-P'},
  { label: 'COTA-DNM', value: 'COTA-DNM'},
  { label: 'COTA-HHCAP', value: 'COTA-HHCAP'},
  { label: 'COTA-HHCCN', value: 'COTA-HHCCN'},
  { label: 'COTA-INS', value: 'COTA-INS'},
  { label: 'COTA-LINK', value: 'COTA-LINK'},
  { label: 'COTA-MED', value: 'COTA-MED'},
  { label: 'COTA-NO VO', value: 'COTA-NO VO'},
  { label: 'COTA-NOMNC', value: 'COTA-NOMNC'},
  { label: 'COTA-SUP', value: 'COTA-SUP'},
  { label: 'CT-CC', value: 'CT-CC'},
  { label: 'CT-CCD', value: 'CT-CCD'},
  { label: 'CT-CONSENT', value: 'CT-CONSENT'},
  { label: 'CT-EPCC', value: 'CT-EPCC'},
  { label: 'CT-GLUCOSE', value: 'CT-GLUCOSE'},
  { label: 'CT-IN', value: 'CT-IN'},
  { label: 'CT-INFECTI', value: 'CT-INFECTI'},
  { label: 'CT-INSERV', value: 'CT-INSERV'},
  { label: 'CT-LYMPH', value: 'CT-LYMPH'},
  { label: 'CT-MEDISET', value: 'CT-MEDISET'},
  { label: 'CT-MEDREC', value: 'CT-MEDREC'},
  { label: 'CT-PHONE', value: 'CT-PHONE'},
  { label: 'CT-PTEXP', value: 'CT-PTEXP'},
  { label: 'CT-PUGETX', value: 'CT-PUGETX'},
  { label: 'CT-SA', value: 'CT-SA'},
  { label: 'CT-TASKS', value: 'CT-TASKS'},
  { label: 'CT-WELLCAL', value: 'CT-WELLCAL'},
  { label: 'CT-WKNDTUK', value: 'CT-WKNDTUK'},
  { label: 'CT-ZONE', value: 'CT-ZONE'},
  { label: 'CT11', value: 'CT11'},
  { label: 'CT11-EXT', value: 'CT11-EXT'},
  { label: 'CT11-TELE', value: 'CT11-TELE'},
  { label: 'CT11-TELP', value: 'CT11-TELP'},
  { label: 'CT11H', value: 'CT11H'},
  { label: 'CT11M', value: 'CT11M'},
  { label: 'CT11N', value: 'CT11N'},
  { label: 'CT11N-TELE', value: 'CT11N-TELE'},
  { label: 'CT11N-TELP', value: 'CT11N-TELP'},
  { label: 'CT11P', value: 'CT11P'},
  { label: 'CT11PP', value: 'CT11PP'},
  { label: 'CT12', value: 'CT12'},
  { label: 'CT13', value: 'CT13'},
  { label: 'CT91', value: 'CT91'},
  { label: 'CT97', value: 'CT97'},
  { label: 'CTATTV', value: 'CTATTV'},
  { label: 'CTCHOV', value: 'CTCHOV'},
  { label: 'CTCOMV', value: 'CTCOMV'},
  { label: 'CTFPCP', value: 'CTFPCP'},
  { label: 'CTHHA', value: 'CTHHA'},
  { label: 'CTHHABA', value: 'CTHHABA'},
  { label: 'CTHHABASIC', value: 'CTHHABASIC'},
  { label: 'CTHHAEXT', value: 'CTHHAEXT'},
  { label: 'CTHHAEXTA', value: 'CTHHAEXTA'},
  { label: 'CTHHAV', value: 'CTHHAV'},
  { label: 'CTHMKV', value: 'CTHMKV'},
  { label: 'CTHMR1D', value: 'CTHMR1D'},
  { label: 'CTHMR1H', value: 'CTHMR1H'},
  { label: 'CTHMR3D', value: 'CTHMR3D'},
  { label: 'CTHMR3H', value: 'CTHMR3H'},
  { label: 'CTHMU5', value: 'CTHMU5'},
  { label: 'CTHMV', value: 'CTHMV'},
  { label: 'CTIHSSFPCP', value: 'CTIHSSFPCP'},
  { label: 'CTIHSSHMKV', value: 'CTIHSSHMKV'},
  { label: 'CTIHSSPCP', value: 'CTIHSSPCP'},
  { label: 'CTLPNV', value: 'CTLPNV'},
  { label: 'CTPCPV', value: 'CTPCPV'},
  { label: 'CTRESV', value: 'CTRESV'},
  { label: 'E-PREP LPN', value: 'E-PREP LPN'},
  { label: 'E-PREP OT', value: 'E-PREP OT'},
  { label: 'E-PREP PT', value: 'E-PREP PT'},
  { label: 'E-PREP RN', value: 'E-PREP RN'},
  { label: 'E-PREP ST', value: 'E-PREP ST'},
  { label: 'EMERG PREP', value: 'EMERG PREP'},
  { label: 'F2FDUE', value: 'F2FDUE'},
  { label: 'HCBS DCNV', value: 'HCBS DCNV'},
  { label: 'HCBS SUP', value: 'HCBS SUP'},
  { label: 'HCBS-RECER', value: 'HCBS-RECER'},
  { label: 'HCBS-SIGNP', value: 'HCBS-SIGNP'},
  { label: 'HCBS-TRNG', value: 'HCBS-TRNG'},
  { label: 'HCBSCP', value: 'HCBSCP'},
  { label: 'HH-BATHP', value: 'HH-BATHP'},
  { label: 'HH-FOOTP', value: 'HH-FOOTP'},
  { label: 'HH-NO VO', value: 'HH-NO VO'},
  { label: 'HH-PRN', value: 'HH-PRN'},
  { label: 'HH-SA', value: 'HH-SA'},
  { label: 'HH11', value: 'HH11'},
  { label: 'HH11-EXT', value: 'HH11-EXT'},
  { label: 'HH11H', value: 'HH11H'},
  { label: 'HH11H-EXT', value: 'HH11H-EXT'},
  { label: 'HH11HN', value: 'HH11HN'},
  { label: 'HH11N', value: 'HH11N'},
  { label: 'HH11NP', value: 'HH11NP'},
  { label: 'HH11P', value: 'HH11P'},
  { label: 'HH11P-BATH', value: 'HH11P-BATH'},
  { label: 'HH11P-FOOT', value: 'HH11P-FOOT'},
  { label: 'HH11R', value: 'HH11R'},
  { label: 'HH12', value: 'HH12'},
  { label: 'HH12H', value: 'HH12H'},
  { label: 'HH14P', value: 'HH14P'},
  { label: 'HH70H', value: 'HH70H'},
  { label: 'HH98-IN', value: 'HH98-IN'},
  { label: 'HH98-OUT', value: 'HH98-OUT'},
  { label: 'HHA-DCPLAN', value: 'HHA-DCPLAN'},
  { label: 'HHA-INS', value: 'HHA-INS'},
  { label: 'HHA-NOMNC', value: 'HHA-NOMNC'},
  { label: 'HHA-PTEXPH', value: 'HHA-PTEXPH'},
  { label: 'HHA-TI', value: 'HHA-TI'},
  { label: 'HHA-TRNG', value: 'HHA-TRNG'},
  { label: 'HHPRNH', value: 'HHPRNH'},
  { label: 'HMA', value: 'HMA'},
  { label: 'HMA90', value: 'HMA90'},
  { label: 'HMAE', value: 'HMAE'},
  { label: 'HMAR', value: 'HMAR'},
  { label: 'HMAS', value: 'HMAS'},
  { label: 'HOME-MP', value: 'HOME-MP'},
  { label: 'HOME-P', value: 'HOME-P'},
  { label: 'I-CH', value: 'I-CH'},
  { label: 'I-MKTR', value: 'I-MKTR'},
  { label: 'I-MSW', value: 'I-MSW'},
  { label: 'I-SN', value: 'I-SN'},
  { label: 'IVR-PRN', value: 'IVR-PRN'},
  { label: 'IVR00', value: 'IVR00'},
  { label: 'IVR01', value: 'IVR01'},
  { label: 'IVR02', value: 'IVR02'},
  { label: 'IVR05', value: 'IVR05'},
  { label: 'IVR10', value: 'IVR10'},
  { label: 'IVR11', value: 'IVR11'},
  { label: 'IVR15', value: 'IVR15'},
  { label: 'IVR17', value: 'IVR17'},
  { label: 'IVR18', value: 'IVR18'},
  { label: 'IVR19', value: 'IVR19'},
  { label: 'LL00', value: 'LL00'},
  { label: 'LL11', value: 'LL11'},
  { label: 'LL12', value: 'LL12'},
  { label: 'LL13', value: 'LL13'},
  { label: 'LL15', value: 'LL15'},
  { label: 'LL19', value: 'LL19'},
  { label: 'LL20', value: 'LL20'},
  { label: 'LL21', value: 'LL21'},
  { label: 'LL22', value: 'LL22'},
  { label: 'LL23', value: 'LL23'},
  { label: 'LP-NONCVRD', value: 'LP-NONCVRD'},
  { label: 'LP11HN-TEL', value: 'LP11HN-TEL'},
  { label: 'LPN-ABN', value: 'LPN-ABN'},
  { label: 'LPN-BRIDGE', value: 'LPN-BRIDGE'},
  { label: 'LPN-CC', value: 'LPN-CC'},
  { label: 'LPN-CCD', value: 'LPN-CCD'},
  { label: 'LPN-CONSEN', value: 'LPN-CONSEN'},
  { label: 'LPN-DNM', value: 'LPN-DNM'},
  { label: 'LPN-F2FDUE', value: 'LPN-F2FDUE'},
  { label: 'LPN-FLU', value: 'LPN-FLU'},
  { label: 'LPN-HHCCN', value: 'LPN-HHCCN'},
  { label: 'LPN-IN', value: 'LPN-IN'},
  { label: 'LPN-INIT', value: 'LPN-INIT'},
  { label: 'LPN-INS', value: 'LPN-INS'},
  { label: 'LPN-INSERV', value: 'LPN-INSERV'},
  { label: 'LPN-LINK', value: 'LPN-LINK'},
  { label: 'LPN-MED', value: 'LPN-MED'},
  { label: 'LPN-MEDPLA', value: 'LPN-MEDPLA'},
  { label: 'LPN-MEDREC', value: 'LPN-MEDREC'},
  { label: 'LPN-NO VO', value: 'LPN-NO VO'},
  { label: 'LPN-NOMNC', value: 'LPN-NOMNC'},
  { label: 'LPN-PHONE', value: 'LPN-PHONE'},
  { label: 'LPN-PHOTO', value: 'LPN-PHOTO'},
  { label: 'LPN-PRN', value: 'LPN-PRN'},
  { label: 'LPN-PT/INR', value: 'LPN-PT/INR'},
  { label: 'LPN-PTEXP', value: 'LPN-PTEXP'},
  { label: 'LPN-PTEXPH', value: 'LPN-PTEXPH'},
  { label: 'LPN-PUGETX', value: 'LPN-PUGETX'},
  { label: 'LPN-TI', value: 'LPN-TI'},
  { label: 'LPN-TRACH', value: 'LPN-TRACH'},
  { label: 'LPN-UNNA', value: 'LPN-UNNA'},
  { label: 'LPN-VC', value: 'LPN-VC'},
  { label: 'LPN-WNDMGT', value: 'LPN-WNDMGT'},
  { label: 'LPN-WNDVAC', value: 'LPN-WNDVAC'},
  { label: 'LPN-ZONE', value: 'LPN-ZONE'},
  { label: 'LPN11', value: 'LPN11'},
  { label: 'LPN11-EXT', value: 'LPN11-EXT'},
  { label: 'LPN11-TELE', value: 'LPN11-TELE'},
  { label: 'LPN11-TELP', value: 'LPN11-TELP'},
  { label: 'LPN11H', value: 'LPN11H'},
  { label: 'LPN11H-EXT', value: 'LPN11H-EXT'},
  { label: 'LPN11N-TEL', value: 'LPN11N-TEL'},
  { label: 'LPN11N-TEP', value: 'LPN11N-TEP'},
  { label: 'LPN11P', value: 'LPN11P'},
  { label: 'LPN12', value: 'LPN12'},
  { label: 'LPN13', value: 'LPN13'},
  { label: 'LPN15', value: 'LPN15'},
  { label: 'LPN30', value: 'LPN30'},
  { label: 'LPN31', value: 'LPN31'},
  { label: 'LPN32H', value: 'LPN32H'},
  { label: 'LPN48HP', value: 'LPN48HP'},
  { label: 'LPN90', value: 'LPN90'},
  { label: 'LPN91', value: 'LPN91'},
  { label: 'LPN93', value: 'LPN93'},
  { label: 'LPN94', value: 'LPN94'},
  { label: 'LPN95', value: 'LPN95'},
  { label: 'LPN96', value: 'LPN96'},
  { label: 'LPN97', value: 'LPN97'},
  { label: 'LPN98', value: 'LPN98'},
  { label: 'LPNGLUCOSE', value: 'LPNGLUCOSE'},
  { label: 'LPNMEDISET', value: 'LPNMEDISET'},
  { label: 'LPNPHONE-H', value: 'LPNPHONE-H'},
  { label: 'LPNPLEURAL', value: 'LPNPLEURAL'},
  { label: 'LPNPRNH', value: 'LPNPRNH'},
  { label: 'LPNTRACH1', value: 'LPNTRACH1'},
  { label: 'LPNTRACH10', value: 'LPNTRACH10'},
  { label: 'LPNTRACH12', value: 'LPNTRACH12'},
  { label: 'LPNTRACH14', value: 'LPNTRACH14'},
  { label: 'LPNTRACH16', value: 'LPNTRACH16'},
  { label: 'LPNTRACH2', value: 'LPNTRACH2'},
  { label: 'LPNTRACH4', value: 'LPNTRACH4'},
  { label: 'LPNTRACH6', value: 'LPNTRACH6'},
  { label: 'LPNTRACH8', value: 'LPNTRACH8'},
  { label: 'LPNTRACH85', value: 'LPNTRACH85'},
  { label: 'LPNTRACH9', value: 'LPNTRACH9'},
  { label: 'MA01', value: 'MA01'},
  { label: 'MA01H', value: 'MA01H'},
  { label: 'MA11', value: 'MA11'},
  { label: 'MA11H', value: 'MA11H'},
  { label: 'MD APPT(PT', value: 'MD APPT(PT'},
  { label: 'MD APPT(RN', value: 'MD APPT(RN'},
  { label: 'MD APPT(ST', value: 'MD APPT(ST'},
  { label: 'MNP-M00X', value: 'MNP-M00X'},
  { label: 'MNP-M02X', value: 'MNP-M02X'},
  { label: 'MNP-M11', value: 'MNP-M11'},
  { label: 'MNP-M11R', value: 'MNP-M11R'},
  { label: 'MNP-N00X', value: 'MNP-N00X'},
  { label: 'MNP-N02X', value: 'MNP-N02X'},
  { label: 'MNP-N11', value: 'MNP-N11'},
  { label: 'MNP-N11R', value: 'MNP-N11R'},
  { label: 'MS-CC', value: 'MS-CC'},
  { label: 'MS-CONSENT', value: 'MS-CONSENT'},
  { label: 'MS-DNM', value: 'MS-DNM'},
  { label: 'MS-HHCCN', value: 'MS-HHCCN'},
  { label: 'MS-NOMNC', value: 'MS-NOMNC'},
  { label: 'MS-POCH', value: 'MS-POCH'},
  { label: 'MS-PRN', value: 'MS-PRN'},
  { label: 'MS-PTEXP', value: 'MS-PTEXP'},
  { label: 'MS-PUGETX', value: 'MS-PUGETX'},
  { label: 'MS-TI', value: 'MS-TI'},
  { label: 'MS-TIP', value: 'MS-TIP'},
  { label: 'MS01', value: 'MS01'},
  { label: 'MS01-TELE', value: 'MS01-TELE'},
  { label: 'MS01-TELP', value: 'MS01-TELP'},
  { label: 'MS01H', value: 'MS01H'},
  { label: 'MS01HN-TEL', value: 'MS01HN-TEL'},
  { label: 'MS01HP', value: 'MS01HP'},
  { label: 'MS01N-TELE', value: 'MS01N-TELE'},
  { label: 'MS01N-TELP', value: 'MS01N-TELP'},
  { label: 'MS06', value: 'MS06'},
  { label: 'MS11', value: 'MS11'},
  { label: 'MS11-TELE', value: 'MS11-TELE'},
  { label: 'MS11-TELP', value: 'MS11-TELP'},
  { label: 'MS11H', value: 'MS11H'},
  { label: 'MS11HN-TEL', value: 'MS11HN-TEL'},
  { label: 'MS11HP', value: 'MS11HP'},
  { label: 'MS11N', value: 'MS11N'},
  { label: 'MS11N-TELE', value: 'MS11N-TELE'},
  { label: 'MS11N-TELP', value: 'MS11N-TELP'},
  { label: 'MS11P', value: 'MS11P'},
  { label: 'MS19', value: 'MS19'},
  { label: 'MS19H', value: 'MS19H'},
  { label: 'MS19N', value: 'MS19N'},
  { label: 'MS40H', value: 'MS40H'},
  { label: 'MS72H', value: 'MS72H'},
  { label: 'MS72HP', value: 'MS72HP'},
  { label: 'MSCOSIGN', value: 'MSCOSIGN'},
  { label: 'MSIH', value: 'MSIH'},
  { label: 'MSPRNH', value: 'MSPRNH'},
  { label: 'MSPRNHP', value: 'MSPRNHP'},
  { label: 'MSW-LINK', value: 'MSW-LINK'},
  { label: 'MSW-NO VO', value: 'MSW-NO VO'},
  { label: 'MSW-PHONE', value: 'MSW-PHONE'},
  { label: 'MSW-PTEXPH', value: 'MSW-PTEXPH'},
  { label: 'MSW-VCH', value: 'MSW-VCH'},
  { label: 'MU01H', value: 'MU01H'},
  { label: 'MU11H', value: 'MU11H'},
  { label: 'MU72H', value: 'MU72H'},
  { label: 'MU72HP', value: 'MU72HP'},
  { label: 'NP - PHONE', value: 'NP - PHONE'},
  { label: 'NP-HF2F', value: 'NP-HF2F'},
  { label: 'NP11', value: 'NP11'},
  { label: 'NP11H', value: 'NP11H'},
  { label: 'NS00-P', value: 'NS00-P'},
  { label: 'NS02P', value: 'NS02P'},
  { label: 'NT01N', value: 'NT01N'},
  { label: 'OP-SUPPLY', value: 'OP-SUPPLY'},
  { label: 'OPTIONALS', value: 'OPTIONALS'},
  { label: 'ORTHO-VTLS', value: 'ORTHO-VTLS'},
  { label: 'OT-BRIDGE', value: 'OT-BRIDGE'},
  { label: 'OT-CC', value: 'OT-CC'},
  { label: 'OT-CCD', value: 'OT-CCD'},
  { label: 'OT-CONSENT', value: 'OT-CONSENT'},
  { label: 'OT-DNM', value: 'OT-DNM'},
  { label: 'OT-DSGREM', value: 'OT-DSGREM'},
  { label: 'OT-EPCC', value: 'OT-EPCC'},
  { label: 'OT-GLUCOSE', value: 'OT-GLUCOSE'},
  { label: 'OT-HHCAPS', value: 'OT-HHCAPS'},
  { label: 'OT-HHCCN', value: 'OT-HHCCN'},
  { label: 'OT-IN', value: 'OT-IN'},
  { label: 'OT-INFECTI', value: 'OT-INFECTI'},
  { label: 'OT-INS', value: 'OT-INS'},
  { label: 'OT-INSERV', value: 'OT-INSERV'},
  { label: 'OT-KAISER', value: 'OT-KAISER'},
  { label: 'OT-LINK', value: 'OT-LINK'},
  { label: 'OT-LYMPH', value: 'OT-LYMPH'},
  { label: 'OT-MED', value: 'OT-MED'},
  { label: 'OT-MEDISET', value: 'OT-MEDISET'},
  { label: 'OT-MEDREC', value: 'OT-MEDREC'},
  { label: 'OT-NO VO', value: 'OT-NO VO'},
  { label: 'OT-NOMNC', value: 'OT-NOMNC'},
  { label: 'OT-P&O', value: 'OT-P&O'},
  { label: 'OT-PHONE', value: 'OT-PHONE'},
  { label: 'OT-POC', value: 'OT-POC'},
  { label: 'OT-PTEXP', value: 'OT-PTEXP'},
  { label: 'OT-PUGETX', value: 'OT-PUGETX'},
  { label: 'OT-SA', value: 'OT-SA'},
  { label: 'OT-SUP', value: 'OT-SUP'},
  { label: 'OT-VC', value: 'OT-VC'},
  { label: 'OT-VESTIB', value: 'OT-VESTIB'},
  { label: 'OT-WELLCAL', value: 'OT-WELLCAL'},
  { label: 'OT-WKNDTUK', value: 'OT-WKNDTUK'},
  { label: 'OT-ZONE', value: 'OT-ZONE'},
  { label: 'OT00', value: 'OT00'},
  { label: 'OT00XP', value: 'OT00XP'},
  { label: 'OT01', value: 'OT01'},
  { label: 'OT01H', value: 'OT01H'},
  { label: 'OT01P', value: 'OT01P'},
  { label: 'OT01PP', value: 'OT01PP'},
  { label: 'OT02', value: 'OT02'},
  { label: 'OT02PP', value: 'OT02PP'},
  { label: 'OT02XP', value: 'OT02XP'},
  { label: 'OT04', value: 'OT04'},
  { label: 'OT04NX', value: 'OT04NX'},
  { label: 'OT05', value: 'OT05'},
  { label: 'OT06', value: 'OT06'},
  { label: 'OT06P', value: 'OT06P'},
  { label: 'OT10', value: 'OT10'},
  { label: 'OT10N', value: 'OT10N'},
  { label: 'OT11', value: 'OT11'},
  { label: 'OT11-EXT', value: 'OT11-EXT'},
  { label: 'OT11-TELE', value: 'OT11-TELE'},
  { label: 'OT11-TELP', value: 'OT11-TELP'},
  { label: 'OT11H', value: 'OT11H'},
  { label: 'OT11M', value: 'OT11M'},
  { label: 'OT11N', value: 'OT11N'},
  { label: 'OT11N-TELE', value: 'OT11N-TELE'},
  { label: 'OT11N-TELP', value: 'OT11N-TELP'},
  { label: 'OT11P', value: 'OT11P'},
  { label: 'OT11PP', value: 'OT11PP'},
  { label: 'OT12', value: 'OT12'},
  { label: 'OT13', value: 'OT13'},
  { label: 'OT15', value: 'OT15'},
  { label: 'OT17', value: 'OT17'},
  { label: 'OT18', value: 'OT18'},
  { label: 'OT18XP', value: 'OT18XP'},
  { label: 'OT19', value: 'OT19'},
  { label: 'OT19N', value: 'OT19N'},
  { label: 'OT19P', value: 'OT19P'},
  { label: 'OT19PP', value: 'OT19PP'},
  { label: 'OT33', value: 'OT33'},
  { label: 'OT33P', value: 'OT33P'},
  { label: 'OT33PP', value: 'OT33PP'},
  { label: 'OT44', value: 'OT44'},
  { label: 'OT66', value: 'OT66'},
  { label: 'OT88', value: 'OT88'},
  { label: 'OT91', value: 'OT91'},
  { label: 'OT97', value: 'OT97'},
  { label: 'OT98-IN', value: 'OT98-IN'},
  { label: 'OT98-OUT', value: 'OT98-OUT'},
  { label: 'OTB01X', value: 'OTB01X'},
  { label: 'OTB11', value: 'OTB11'},
  { label: 'OTB18X', value: 'OTB18X'},
  { label: 'OTSUPAIDE', value: 'OTSUPAIDE'},
  { label: 'OTSUPASST', value: 'OTSUPASST'},
  { label: 'PA-ABN', value: 'PA-ABN'},
  { label: 'PA-CC', value: 'PA-CC'},
  { label: 'PA-CONSENT', value: 'PA-CONSENT'},
  { label: 'PA-DCPLAN', value: 'PA-DCPLAN'},
  { label: 'PA-HHCCN', value: 'PA-HHCCN'},
  { label: 'PA-INFECTI', value: 'PA-INFECTI'},
  { label: 'PA-INSERV', value: 'PA-INSERV'},
  { label: 'PA-NOMNC', value: 'PA-NOMNC'},
  { label: 'PA-PHONE', value: 'PA-PHONE'},
  { label: 'PA-SA', value: 'PA-SA'},
  { label: 'PA-WELLCAL', value: 'PA-WELLCAL'},
  { label: 'PA-WKNDTUK', value: 'PA-WKNDTUK'},
  { label: 'PA-ZONE', value: 'PA-ZONE'},
  { label: 'PA11', value: 'PA11'},
  { label: 'PA11-EXT', value: 'PA11-EXT'},
  { label: 'PA11-TELE', value: 'PA11-TELE'},
  { label: 'PA11-TELP', value: 'PA11-TELP'},
  { label: 'PA11H', value: 'PA11H'},
  { label: 'PA11M', value: 'PA11M'},
  { label: 'PA11N', value: 'PA11N'},
  { label: 'PA11N-TELE', value: 'PA11N-TELE'},
  { label: 'PA11N-TELP', value: 'PA11N-TELP'},
  { label: 'PA11P', value: 'PA11P'},
  { label: 'PA11PP', value: 'PA11PP'},
  { label: 'PA11RS', value: 'PA11RS'},
  { label: 'PA91', value: 'PA91'},
  { label: 'PA97', value: 'PA97'},
  { label: 'PA98-IN', value: 'PA98-IN'},
  { label: 'PA98-OUT', value: 'PA98-OUT'},
  { label: 'PALL - DC', value: 'PALL - DC'},
  { label: 'PALL - MSW', value: 'PALL - MSW'},
  { label: 'PALL - SN', value: 'PALL - SN'},
  { label: 'PALL - SUB', value: 'PALL - SUB'},
  { label: 'PALL-ADMIN', value: 'PALL-ADMIN'},
  { label: 'PALL-HOS A', value: 'PALL-HOS A'},
  { label: 'PALL-NP IN', value: 'PALL-NP IN'},
  { label: 'PALL-SN IN', value: 'PALL-SN IN'},
  { label: 'PCA', value: 'PCA'},
  { label: 'PCA-2ND CG', value: 'PCA-2ND CG'},
  { label: 'PCA-L1', value: 'PCA-L1'},
  { label: 'PCA-L2', value: 'PCA-L2'},
  { label: 'PCA-L3', value: 'PCA-L3'},
  { label: 'PCA-L4', value: 'PCA-L4'},
  { label: 'PCA-RESV', value: 'PCA-RESV'},
  { label: 'PCS-ATT', value: 'PCS-ATT'},
  { label: 'PCS-COMP', value: 'PCS-COMP'},
  { label: 'PCS-HMK', value: 'PCS-HMK'},
  { label: 'PCS-PCS', value: 'PCS-PCS'},
  { label: 'PCS365SUP', value: 'PCS365SUP'},
  { label: 'PCS90SUP', value: 'PCS90SUP'},
  { label: 'PCSADMNCP', value: 'PCSADMNCP'},
  { label: 'PCSADMNDCN', value: 'PCSADMNDCN'},
  { label: 'PCSADMNSUP', value: 'PCSADMNSUP'},
  { label: 'PCSADMNTRN', value: 'PCSADMNTRN'},
  { label: 'PCSATTV', value: 'PCSATTV'},
  { label: 'PCSCHOV', value: 'PCSCHOV'},
  { label: 'PCSCOMV', value: 'PCSCOMV'},
  { label: 'PCSFPCP', value: 'PCSFPCP'},
  { label: 'PCSHHA', value: 'PCSHHA'},
  { label: 'PCSHHABA', value: 'PCSHHABA'},
  { label: 'PCSHHABSC', value: 'PCSHHABSC'},
  { label: 'PCSHHAEXT', value: 'PCSHHAEXT'},
  { label: 'PCSHHAEXTA', value: 'PCSHHAEXTA'},
  { label: 'PCSHHAV', value: 'PCSHHAV'},
  { label: 'PCSHMKV', value: 'PCSHMKV'},
  { label: 'PCSHMR1D', value: 'PCSHMR1D'},
  { label: 'PCSHMR1H', value: 'PCSHMR1H'},
  { label: 'PCSHMR3D', value: 'PCSHMR3D'},
  { label: 'PCSHMR3H', value: 'PCSHMR3H'},
  { label: 'PCSHMU5', value: 'PCSHMU5'},
  { label: 'PCSHMV', value: 'PCSHMV'},
  { label: 'PCSIHSSF', value: 'PCSIHSSF'},
  { label: 'PCSIHSSHMK', value: 'PCSIHSSHMK'},
  { label: 'PCSIHSSPCP', value: 'PCSIHSSPCP'},
  { label: 'PCSLPNV', value: 'PCSLPNV'},
  { label: 'PCSPCPV', value: 'PCSPCPV'},
  { label: 'PCSRESV', value: 'PCSRESV'},
  { label: 'PCSTASKS', value: 'PCSTASKS'},
  { label: 'PD-CVDSCRN', value: 'PD-CVDSCRN'},
  { label: 'PDOT01', value: 'PDOT01'},
  { label: 'PDOT02X', value: 'PDOT02X'},
  { label: 'PDOT06', value: 'PDOT06'},
  { label: 'PDOT11', value: 'PDOT11'},
  { label: 'PDOT18X', value: 'PDOT18X'},
  { label: 'PDOT19', value: 'PDOT19'},
  { label: 'PDOT33', value: 'PDOT33'},
  { label: 'PDOT44X', value: 'PDOT44X'},
  { label: 'PDOT66X', value: 'PDOT66X'},
  { label: 'PDR-LPN11', value: 'PDR-LPN11'},
  { label: 'PDR-PRN', value: 'PDR-PRN'},
  { label: 'PDR00X', value: 'PDR00X'},
  { label: 'PDR02X', value: 'PDR02X'},
  { label: 'PDR05X', value: 'PDR05X'},
  { label: 'PDR10', value: 'PDR10'},
  { label: 'PDR11', value: 'PDR11'},
  { label: 'PDR11N', value: 'PDR11N'},
  { label: 'PDR15X', value: 'PDR15X'},
  { label: 'PDR18X', value: 'PDR18X'},
  { label: 'PDR19', value: 'PDR19'},
  { label: 'PDR44X', value: 'PDR44X'},
  { label: 'PDR66X', value: 'PDR66X'},
  { label: 'PDS-PRN', value: 'PDS-PRN'},
  { label: 'PDS11', value: 'PDS11'},
  { label: 'PHLEBOTOMY', value: 'PHLEBOTOMY'},
  { label: 'PHY-HF2F', value: 'PHY-HF2F'},
  { label: 'PHY11H', value: 'PHY11H'},
  { label: 'PHY11H-TEL', value: 'PHY11H-TEL'},
  { label: 'PHYPRN-TEL', value: 'PHYPRN-TEL'},
  { label: 'PHYS-PREH', value: 'PHYS-PREH'},
  { label: 'PP-24', value: 'PP-24'},
  { label: 'PP-24-HOL', value: 'PP-24-HOL'},
  { label: 'PP-24-WK', value: 'PP-24-WK'},
  { label: 'PP-D', value: 'PP-D'},
  { label: 'PP-D-HOL', value: 'PP-D-HOL'},
  { label: 'PP-D-WK', value: 'PP-D-WK'},
  { label: 'PP-N', value: 'PP-N'},
  { label: 'PP-N-HOL', value: 'PP-N-HOL'},
  { label: 'PP-N-WK', value: 'PP-N-WK'},
  { label: 'PSY00N', value: 'PSY00N'},
  { label: 'PSY02N', value: 'PSY02N'},
  { label: 'PT- MED', value: 'PT- MED'},
  { label: 'PT-AUTH', value: 'PT-AUTH'},
  { label: 'PT-BRIDGE', value: 'PT-BRIDGE'},
  { label: 'PT-CC', value: 'PT-CC'},
  { label: 'PT-CCD', value: 'PT-CCD'},
  { label: 'PT-CONSENT', value: 'PT-CONSENT'},
  { label: 'PT-DCPLAN', value: 'PT-DCPLAN'},
  { label: 'PT-DNM', value: 'PT-DNM'},
  { label: 'PT-DSGREM', value: 'PT-DSGREM'},
  { label: 'PT-EPCC', value: 'PT-EPCC'},
  { label: 'PT-GLUCOSE', value: 'PT-GLUCOSE'},
  { label: 'PT-HHCAPS', value: 'PT-HHCAPS'},
  { label: 'PT-HHCCN', value: 'PT-HHCCN'},
  { label: 'PT-INFECTI', value: 'PT-INFECTI'},
  { label: 'PT-INS', value: 'PT-INS'},
  { label: 'PT-INSERV', value: 'PT-INSERV'},
  { label: 'PT-KAISER', value: 'PT-KAISER'},
  { label: 'PT-LINK', value: 'PT-LINK'},
  { label: 'PT-LYMPH', value: 'PT-LYMPH'},
  { label: 'PT-MEDISET', value: 'PT-MEDISET'},
  { label: 'PT-MEDREC', value: 'PT-MEDREC'},
  { label: 'PT-NO VO', value: 'PT-NO VO'},
  { label: 'PT-NOMNC', value: 'PT-NOMNC'},
  { label: 'PT-P&O', value: 'PT-P&O'},
  { label: 'PT-PHONE', value: 'PT-PHONE'},
  { label: 'PT-POC', value: 'PT-POC'},
  { label: 'PT-PTEXP', value: 'PT-PTEXP'},
  { label: 'PT-PUGETX', value: 'PT-PUGETX'},
  { label: 'PT-SA', value: 'PT-SA'},
  { label: 'PT-SUP', value: 'PT-SUP'},
  { label: 'PT-SUP-PP', value: 'PT-SUP-PP'},
  { label: 'PT-VC', value: 'PT-VC'},
  { label: 'PT-VESTIB', value: 'PT-VESTIB'},
  { label: 'PT-WCE', value: 'PT-WCE'},
  { label: 'PT-WELLCAL', value: 'PT-WELLCAL'},
  { label: 'PT-WKNDTUK', value: 'PT-WKNDTUK'},
  { label: 'PT-WNDMGT', value: 'PT-WNDMGT'},
  { label: 'PT-ZONE', value: 'PT-ZONE'},
  { label: 'PT97', value: 'PT97'},
  { label: 'PTA-CCD', value: 'PTA-CCD'},
  { label: 'PTA-DNM', value: 'PTA-DNM'},
  { label: 'PTA-EPCC', value: 'PTA-EPCC'},
  { label: 'PTA-HHCAPS', value: 'PTA-HHCAPS'},
  { label: 'PTA-INS', value: 'PTA-INS'},
  { label: 'PTA-LINK', value: 'PTA-LINK'},
  { label: 'PTA-LYMPH', value: 'PTA-LYMPH'},
  { label: 'PTA-MED', value: 'PTA-MED'},
  { label: 'PTA-MEDREC', value: 'PTA-MEDREC'},
  { label: 'PTA-NO VO', value: 'PTA-NO VO'},
  { label: 'PTA-NOMNC', value: 'PTA-NOMNC'},
  { label: 'PTA-PTEXP', value: 'PTA-PTEXP'},
  { label: 'PTA-PUGETX', value: 'PTA-PUGETX'},
  { label: 'PTAGLUCOSE', value: 'PTAGLUCOSE'},
  { label: 'PTAMEDISET', value: 'PTAMEDISET'},
  { label: 'PTB01X', value: 'PTB01X'},
  { label: 'PTB11', value: 'PTB11'},
  { label: 'PTB18X', value: 'PTB18X'},
  { label: 'PTIHR11', value: 'PTIHR11'},
  { label: 'PTSUPAIDE', value: 'PTSUPAIDE'},
  { label: 'PTSUPASST', value: 'PTSUPASST'},
  { label: 'RD01', value: 'RD01'},
  { label: 'RD01H', value: 'RD01H'},
  { label: 'RD11', value: 'RD11'},
  { label: 'RD11H', value: 'RD11H'},
  { label: 'RD19', value: 'RD19'},
  { label: 'RECERT IDG', value: 'RECERT IDG'},
  { label: 'RN - NOMNC', value: 'RN - NOMNC'},
  { label: 'RN-60 DAY', value: 'RN-60 DAY'},
  { label: 'RN-AIDESUP', value: 'RN-AIDESUP'},
  { label: 'RN-AUTH', value: 'RN-AUTH'},
  { label: 'RN-BRIDGE', value: 'RN-BRIDGE'},
  { label: 'RN-CC', value: 'RN-CC'},
  { label: 'RN-CCD', value: 'RN-CCD'},
  { label: 'RN-CONSENT', value: 'RN-CONSENT'},
  { label: 'RN-DNM', value: 'RN-DNM'},
  { label: 'RN-DSGREM', value: 'RN-DSGREM'},
  { label: 'RN-F2FDUE', value: 'RN-F2FDUE'},
  { label: 'RN-HEART-P', value: 'RN-HEART-P'},
  { label: 'RN-HHCAPS', value: 'RN-HHCAPS'},
  { label: 'RN-HHCCN', value: 'RN-HHCCN'},
  { label: 'RN-IN', value: 'RN-IN'},
  { label: 'RN-INFECTI', value: 'RN-INFECTI'},
  { label: 'RN-INS', value: 'RN-INS'},
  { label: 'RN-INSERV', value: 'RN-INSERV'},
  { label: 'RN-LINK', value: 'RN-LINK'},
  { label: 'RN-LPNSUP', value: 'RN-LPNSUP'},
  { label: 'RN-MED', value: 'RN-MED'},
  { label: 'RN-MEDISET', value: 'RN-MEDISET'},
  { label: 'RN-MEDPLAN', value: 'RN-MEDPLAN'},
  { label: 'RN-MEDREC', value: 'RN-MEDREC'},
  { label: 'RN-NO VO', value: 'RN-NO VO'},
  { label: 'RN-NOMOVE', value: 'RN-NOMOVE'},
  { label: 'RN-NONCVRD', value: 'RN-NONCVRD'},
  { label: 'RN-P&O', value: 'RN-P&O'},
  { label: 'RN-PEDI', value: 'RN-PEDI'},
  { label: 'RN-PHONE', value: 'RN-PHONE'},
  { label: 'RN-PHONE-H', value: 'RN-PHONE-H'},
  { label: 'RN-PHOTO', value: 'RN-PHOTO'},
  { label: 'RN-PLEURAL', value: 'RN-PLEURAL'},
  { label: 'RN-POC', value: 'RN-POC'},
  { label: 'RN-POCH', value: 'RN-POCH'},
  { label: 'RN-PRN', value: 'RN-PRN'},
  { label: 'RN-PRNH', value: 'RN-PRNH'},
  { label: 'RN-PT/INR', value: 'RN-PT/INR'},
  { label: 'RN-PTEXP', value: 'RN-PTEXP'},
  { label: 'RN-PTEXPH', value: 'RN-PTEXPH'},
  { label: 'RN-PUGETX', value: 'RN-PUGETX'},
  { label: 'RN-SUP', value: 'RN-SUP'},
  { label: 'RN-SUPP', value: 'RN-SUPP'},
  { label: 'RN-TIP', value: 'RN-TIP'},
  { label: 'RN-TRACH', value: 'RN-TRACH'},
  { label: 'RN-UNNA', value: 'RN-UNNA'},
  { label: 'RN-VC', value: 'RN-VC'},
  { label: 'RN-WELLCAL', value: 'RN-WELLCAL'},
  { label: 'RN-WKNDTUK', value: 'RN-WKNDTUK'},
  { label: 'RN-WND VAC', value: 'RN-WND VAC'},
  { label: 'RN-WNDMGT', value: 'RN-WNDMGT'},
  { label: 'RN-WON', value: 'RN-WON'},
  { label: 'RN-ZONE', value: 'RN-ZONE'},
  { label: 'RN00', value: 'RN00'},
  { label: 'RN00-PC', value: 'RN00-PC'},
  { label: 'RN00-PD', value: 'RN00-PD'},
  { label: 'RN00H', value: 'RN00H'},
  { label: 'RN00N', value: 'RN00N'},
  { label: 'RN00P', value: 'RN00P'},
  { label: 'RN00PCX', value: 'RN00PCX'},
  { label: 'RN00PP', value: 'RN00PP'},
  { label: 'RN00X', value: 'RN00X'},
  { label: 'RN01', value: 'RN01'},
  { label: 'RN01P', value: 'RN01P'},
  { label: 'RN02', value: 'RN02'},
  { label: 'RN02H', value: 'RN02H'},
  { label: 'RN02N', value: 'RN02N'},
  { label: 'RN02NP', value: 'RN02NP'},
  { label: 'RN02NX', value: 'RN02NX'},
  { label: 'RN02P', value: 'RN02P'},
  { label: 'RN02PCX', value: 'RN02PCX'},
  { label: 'RN02PP', value: 'RN02PP'},
  { label: 'RN02X', value: 'RN02X'},
  { label: 'RN03', value: 'RN03'},
  { label: 'RN04', value: 'RN04'},
  { label: 'RN04H', value: 'RN04H'},
  { label: 'RN04P', value: 'RN04P'},
  { label: 'RN05', value: 'RN05'},
  { label: 'RN05X', value: 'RN05X'},
  { label: 'RN06', value: 'RN06'},
  { label: 'RN10', value: 'RN10'},
  { label: 'RN10H', value: 'RN10H'},
  { label: 'RN10N', value: 'RN10N'},
  { label: 'RN10NP', value: 'RN10NP'},
  { label: 'RN10P', value: 'RN10P'},
  { label: 'RN11', value: 'RN11'},
  { label: 'RN11-EXT', value: 'RN11-EXT'},
  { label: 'RN11-TELE', value: 'RN11-TELE'},
  { label: 'RN11-TELP', value: 'RN11-TELP'},
  { label: 'RN11H', value: 'RN11H'},
  { label: 'RN11H-EXT', value: 'RN11H-EXT'},
  { label: 'RN11HIP', value: 'RN11HIP'},
  { label: 'RN11HN-TEL', value: 'RN11HN-TEL'},
  { label: 'RN11M', value: 'RN11M'},
  { label: 'RN11N', value: 'RN11N'},
  { label: 'RN11N-TELE', value: 'RN11N-TELE'},
  { label: 'RN11N-TELP', value: 'RN11N-TELP'},
  { label: 'RN11P', value: 'RN11P'},
  { label: 'RN11R', value: 'RN11R'},
  { label: 'RN11R-TELE', value: 'RN11R-TELE'},
  { label: 'RN11RH', value: 'RN11RH'},
  { label: 'RN12', value: 'RN12'},
  { label: 'RN13', value: 'RN13'},
  { label: 'RN15', value: 'RN15'},
  { label: 'RN15X', value: 'RN15X'},
  { label: 'RN17', value: 'RN17'},
  { label: 'RN18', value: 'RN18'},
  { label: 'RN18H', value: 'RN18H'},
  { label: 'RN18PP', value: 'RN18PP'},
  { label: 'RN18X', value: 'RN18X'},
  { label: 'RN19', value: 'RN19'},
  { label: 'RN19N', value: 'RN19N'},
  { label: 'RN30', value: 'RN30'},
  { label: 'RN30H', value: 'RN30H'},
  { label: 'RN31', value: 'RN31'},
  { label: 'RN31H', value: 'RN31H'},
  { label: 'RN32', value: 'RN32'},
  { label: 'RN32H', value: 'RN32H'},
  { label: 'RN44', value: 'RN44'},
  { label: 'RN44X', value: 'RN44X'},
  { label: 'RN66', value: 'RN66'},
  { label: 'RN66H', value: 'RN66H'},
  { label: 'RN66X', value: 'RN66X'},
  { label: 'RN70H', value: 'RN70H'},
  { label: 'RN72H', value: 'RN72H'},
  { label: 'RN72HP', value: 'RN72HP'},
  { label: 'RN88', value: 'RN88'},
  { label: 'RN88H', value: 'RN88H'},
  { label: 'RN88HN', value: 'RN88HN'},
  { label: 'RN88X', value: 'RN88X'},
  { label: 'RN90', value: 'RN90'},
  { label: 'RN91', value: 'RN91'},
  { label: 'RN93', value: 'RN93'},
  { label: 'RN94', value: 'RN94'},
  { label: 'RN94H', value: 'RN94H'},
  { label: 'RN95', value: 'RN95'},
  { label: 'RN96', value: 'RN96'},
  { label: 'RNMANIPEDI', value: 'RNMANIPEDI'},
  { label: 'RNPAINHP', value: 'RNPAINHP'},
  { label: 'RNTRACH1', value: 'RNTRACH1'},
  { label: 'RNTRACH10', value: 'RNTRACH10'},
  { label: 'RNTRACH12', value: 'RNTRACH12'},
  { label: 'RNTRACH14', value: 'RNTRACH14'},
  { label: 'RNTRACH16', value: 'RNTRACH16'},
  { label: 'RNTRACH2', value: 'RNTRACH2'},
  { label: 'RNTRACH4', value: 'RNTRACH4'},
  { label: 'RNTRACH6', value: 'RNTRACH6'},
  { label: 'RNTRACH8', value: 'RNTRACH8'},
  { label: 'RNTRACH8.5', value: 'RNTRACH8.5'},
  { label: 'RNTRACH9', value: 'RNTRACH9'},
  { label: 'RT11', value: 'RT11'},
  { label: 'SLP00', value: 'SLP00'},
  { label: 'SLP01', value: 'SLP01'},
  { label: 'SLP02', value: 'SLP02'},
  { label: 'SLP06', value: 'SLP06'},
  { label: 'SLP11', value: 'SLP11'},
  { label: 'SLP18', value: 'SLP18'},
  { label: 'SLP19', value: 'SLP19'},
  { label: 'SLP33', value: 'SLP33'},
  { label: 'SLPNOMNC', value: 'SLPNOMNC'},
  { label: 'SN-ABN', value: 'SN-ABN'},
  { label: 'SN-CC', value: 'SN-CC'},
  { label: 'SN-CCD', value: 'SN-CCD'},
  { label: 'SN-CONSENT', value: 'SN-CONSENT'},
  { label: 'SN-DNM', value: 'SN-DNM'},
  { label: 'SN-DSGREM', value: 'SN-DSGREM'},
  { label: 'SN-EPCC', value: 'SN-EPCC'},
  { label: 'SN-FLU', value: 'SN-FLU'},
  { label: 'SN-GLUCOSE', value: 'SN-GLUCOSE'},
  { label: 'SN-HHCAPS', value: 'SN-HHCAPS'},
  { label: 'SN-HHCCN', value: 'SN-HHCCN'},
  { label: 'SN-HOSELIG', value: 'SN-HOSELIG'},
  { label: 'SN-IN/OUT', value: 'SN-IN/OUT'},
  { label: 'SN-INFECTI', value: 'SN-INFECTI'},
  { label: 'SN-INIT', value: 'SN-INIT'},
  { label: 'SN-INT-TEL', value: 'SN-INT-TEL'},
  { label: 'SN-KAISER', value: 'SN-KAISER'},
  { label: 'SN-MED', value: 'SN-MED'},
  { label: 'SN-MEDISET', value: 'SN-MEDISET'},
  { label: 'SN-MEDREC', value: 'SN-MEDREC'},
  { label: 'SN-NOMNC', value: 'SN-NOMNC'},
  { label: 'SN-NONCVRD', value: 'SN-NONCVRD'},
  { label: 'SN-NPN', value: 'SN-NPN'},
  { label: 'SN-PHONE', value: 'SN-PHONE'},
  { label: 'SN-PHOTO', value: 'SN-PHOTO'},
  { label: 'SN-PLEURAL', value: 'SN-PLEURAL'},
  { label: 'SN-PNA', value: 'SN-PNA'},
  { label: 'SN-PRN', value: 'SN-PRN'},
  { label: 'SN-PRNH', value: 'SN-PRNH'},
  { label: 'SN-PRNP', value: 'SN-PRNP'},
  { label: 'SN-PSY', value: 'SN-PSY'},
  { label: 'SN-PSYCMED', value: 'SN-PSYCMED'},
  { label: 'SN-PTEXP', value: 'SN-PTEXP'},
  { label: 'SN-PTEXPH', value: 'SN-PTEXPH'},
  { label: 'SN-PUGETX', value: 'SN-PUGETX'},
  { label: 'SN-SA', value: 'SN-SA'},
  { label: 'SN-TI', value: 'SN-TI'},
  { label: 'SN-VC', value: 'SN-VC'},
  { label: 'SN-VCH', value: 'SN-VCH'},
  { label: 'SN-WELLCAL', value: 'SN-WELLCAL'},
  { label: 'SN-WKNDTUK', value: 'SN-WKNDTUK'},
  { label: 'SN-WNDMGT', value: 'SN-WNDMGT'},
  { label: 'SN-ZONE', value: 'SN-ZONE'},
  { label: 'SN01P', value: 'SN01P'},
  { label: 'SN02P', value: 'SN02P'},
  { label: 'SN04P', value: 'SN04P'},
  { label: 'SN11', value: 'SN11'},
  { label: 'SN11-EXT', value: 'SN11-EXT'},
  { label: 'SN11H', value: 'SN11H'},
  { label: 'SN11H-EXT', value: 'SN11H-EXT'},
  { label: 'SN11HIP', value: 'SN11HIP'},
  { label: 'SN11N', value: 'SN11N'},
  { label: 'SN11NP', value: 'SN11NP'},
  { label: 'SN11P', value: 'SN11P'},
  { label: 'SN11PP', value: 'SN11PP'},
  { label: 'SN11R', value: 'SN11R'},
  { label: 'SN11RH', value: 'SN11RH'},
  { label: 'SN12', value: 'SN12'},
  { label: 'SN13', value: 'SN13'},
  { label: 'SN18H', value: 'SN18H'},
  { label: 'SN18P', value: 'SN18P'},
  { label: 'SN20NP', value: 'SN20NP'},
  { label: 'SN20P', value: 'SN20P'},
  { label: 'SN21P', value: 'SN21P'},
  { label: 'SN30', value: 'SN30'},
  { label: 'SN30H', value: 'SN30H'},
  { label: 'SN31', value: 'SN31'},
  { label: 'SN31H', value: 'SN31H'},
  { label: 'SN32', value: 'SN32'},
  { label: 'SN32H', value: 'SN32H'},
  { label: 'SN48HP', value: 'SN48HP'},
  { label: 'SN70H', value: 'SN70H'},
  { label: 'SN72H', value: 'SN72H'},
  { label: 'SN88H', value: 'SN88H'},
  { label: 'SN90', value: 'SN90'},
  { label: 'SN90H', value: 'SN90H'},
  { label: 'SN91', value: 'SN91'},
  { label: 'SN91H', value: 'SN91H'},
  { label: 'SN92H', value: 'SN92H'},
  { label: 'SN93', value: 'SN93'},
  { label: 'SN93H', value: 'SN93H'},
  { label: 'SN94', value: 'SN94'},
  { label: 'SN94H', value: 'SN94H'},
  { label: 'SN95', value: 'SN95'},
  { label: 'SN96', value: 'SN96'},
  { label: 'SN97', value: 'SN97'},
  { label: 'SN98', value: 'SN98'},
  { label: 'SN98-IN', value: 'SN98-IN'},
  { label: 'SN98-OUT', value: 'SN98-OUT'},
  { label: 'SN98H', value: 'SN98H'},
  { label: 'SNIH', value: 'SNIH'},
  { label: 'SNPAINHP', value: 'SNPAINHP'},
  { label: 'SSA', value: 'SSA'},
  { label: 'ST-CC', value: 'ST-CC'},
  { label: 'ST-CCD', value: 'ST-CCD'},
  { label: 'ST-CONSENT', value: 'ST-CONSENT'},
  { label: 'ST-DNM', value: 'ST-DNM'},
  { label: 'ST-EPCC', value: 'ST-EPCC'},
  { label: 'ST-GLUCOSE', value: 'ST-GLUCOSE'},
  { label: 'ST-HHCAPS', value: 'ST-HHCAPS'},
  { label: 'ST-HHCCN', value: 'ST-HHCCN'},
  { label: 'ST-IN', value: 'ST-IN'},
  { label: 'ST-INFECTI', value: 'ST-INFECTI'},
  { label: 'ST-INS', value: 'ST-INS'},
  { label: 'ST-INSERV', value: 'ST-INSERV'},
  { label: 'ST-LINK', value: 'ST-LINK'},
  { label: 'ST-MED', value: 'ST-MED'},
  { label: 'ST-MEDISET', value: 'ST-MEDISET'},
  { label: 'ST-MEDREC', value: 'ST-MEDREC'},
  { label: 'ST-NO VO', value: 'ST-NO VO'},
  { label: 'ST-NOMNC', value: 'ST-NOMNC'},
  { label: 'ST-P&O', value: 'ST-P&O'},
  { label: 'ST-PHONE', value: 'ST-PHONE'},
  { label: 'ST-POC', value: 'ST-POC'},
  { label: 'ST-PTEXP', value: 'ST-PTEXP'},
  { label: 'ST-PUGETX', value: 'ST-PUGETX'},
  { label: 'ST-SA', value: 'ST-SA'},
  { label: 'ST-SUP', value: 'ST-SUP'},
  { label: 'ST-VC', value: 'ST-VC'},
  { label: 'ST-WELLCAL', value: 'ST-WELLCAL'},
  { label: 'ST-WKNDTUK', value: 'ST-WKNDTUK'},
  { label: 'ST00', value: 'ST00'},
  { label: 'ST00P', value: 'ST00P'},
  { label: 'ST00XP', value: 'ST00XP'},
  { label: 'ST01', value: 'ST01'},
  { label: 'ST01H', value: 'ST01H'},
  { label: 'ST01P', value: 'ST01P'},
  { label: 'ST01PP', value: 'ST01PP'},
  { label: 'ST02', value: 'ST02'},
  { label: 'ST02P', value: 'ST02P'},
  { label: 'ST02PP', value: 'ST02PP'},
  { label: 'ST02XP', value: 'ST02XP'},
  { label: 'ST04', value: 'ST04'},
  { label: 'ST05', value: 'ST05'},
  { label: 'ST06 ', value: 'ST06 '},
  { label: 'ST06P', value: 'ST06P'},
  { label: 'ST10', value: 'ST10'},
  { label: 'ST11', value: 'ST11'},
  { label: 'ST11-EXT', value: 'ST11-EXT'},
  { label: 'ST11-TELE', value: 'ST11-TELE'},
  { label: 'ST11-TELP', value: 'ST11-TELP'},
  { label: 'ST11H', value: 'ST11H'},
  { label: 'ST11H-TELE', value: 'ST11H-TELE'},
  { label: 'ST11HN-TEL', value: 'ST11HN-TEL'},
  { label: 'ST11M', value: 'ST11M'},
  { label: 'ST11N', value: 'ST11N'},
  { label: 'ST11N-TELE', value: 'ST11N-TELE'},
  { label: 'ST11N-TELP', value: 'ST11N-TELP'},
  { label: 'ST11P', value: 'ST11P'},
  { label: 'ST11PP', value: 'ST11PP'},
  { label: 'ST15', value: 'ST15'},
  { label: 'ST17', value: 'ST17'},
  { label: 'ST18', value: 'ST18'},
  { label: 'ST18P', value: 'ST18P'},
  { label: 'ST19', value: 'ST19'},
  { label: 'ST19N', value: 'ST19N'},
  { label: 'ST19P', value: 'ST19P'},
  { label: 'ST19PP', value: 'ST19PP'},
  { label: 'ST33', value: 'ST33'},
  { label: 'ST33P', value: 'ST33P'},
  { label: 'ST33PP', value: 'ST33PP'},
  { label: 'ST44', value: 'ST44'},
  { label: 'ST66', value: 'ST66'},
  { label: 'ST88', value: 'ST88'},
  { label: 'ST88H', value: 'ST88H'},
  { label: 'ST97', value: 'ST97'},
  { label: 'ST98-IN', value: 'ST98-IN'},
  { label: 'ST98-OUT', value: 'ST98-OUT'},
  { label: 'STB01X', value: 'STB01X'},
  { label: 'STB11', value: 'STB11'},
  { label: 'STB18X', value: 'STB18X'},
  { label: 'STSUPAIDE', value: 'STSUPAIDE'},
  { label: 'THHA01', value: 'THHA01'},
  { label: 'TRANSPORT', value: 'TRANSPORT'},
  { label: 'UT11', value: 'UT11'},
  { label: 'VA02P-HHA', value: 'VA02P-HHA'},
  { label: 'VA02P-HMA', value: 'VA02P-HMA'},
  { label: 'VC01', value: 'VC01'},
  { label: 'VC11H', value: 'VC11H'},
  { label: 'VOL11', value: 'VOL11'},
  { label: 'RN/W', value: 'RN/W'},
  { label: 'SN-I/W-1', value: 'SN-I/W-1'},
  { label: 'SN-I/W-3', value: 'SN-I/W-3' },
  { label: 'SN-WC', value: 'SN-WC' }
];

export const visitType = [
  { label: 'Follow Up', value: 'follow_up' },
  { label: 'Startup Care', value: 'startup_care' },
];

export enum SubmissionStatusColor {
  all = '',
  inprogress = '#6ACE6A',
  recheck = '#C66A9E',
  reviewed = '#1E38A9',
  completed = '#EF896A',
  waitingforreview = '#6ACE6A',
  incomplete = '#C66A9E'
}
export enum visitDetailColors {
  'Error' = '#C11574',
  'Warning' = '#1E38A9',
  'Ok' = '#6ACE6A',
  'All' = '#F9A51D',
  'Started' = '#6ACE6A',
  'Completed' = '#EF896A',
  'Recheck' = '#C66A9E',
  'Reviewed' = '#1E38A9',
  'In Progress' = '#0A6ED9',
  'Submitted' = '#EF896A',
  'Not Addressed' = '#F9A51D',
  'Needs Correction' = '#C11574',
}

export interface ESockSubmission{
  eSockFile: string;
  email: { email: string, preferred: boolean};
  phoneNumber: { countryCode: string, number: string, preferred: boolean};
  dob?: any;
  isChecked?: boolean;
}

export const PatientVisitRows = [
  {value: 'Q No', label: 'Question'},
  {value: 'Description', label: 'Description'},
  {value: 'Clinical Answer', label: 'Clinical Answer'},
  {value: 'Suggested Answer', label: 'Suggested Answer'},
  {value: 'Clinical Decision', label: 'Clinical Decision'},
  {value: 'Ans Description', label: 'Ans Description'},
  {value: 'Message', label: 'Message'},
  {value: 'Alert Type', label: 'Alert Type'},
  {value: 'Rationale', label: 'Rationale'},
  {value: 'QA Review Status', label: 'QA Review Status'},
  {value: 'Status', label: 'Status'},
  {value: 'Action', label: 'Action'},
  {value: 'QA Notes', label: 'QA Notes'},
];

export const defaultSelectedPatientVisitRows = [
  'Q No',
  'Description',
  'Clinical Answer',
  'Suggested Answer',
  'Clinical Decision',
  'Alert Type',
  'Message',
  'QA Review Status',
  'QA Notes',
  'Action',
];

export const REVIEWED_STATUS = 'reviewed';
export const NOT_ADDRESSED_STATUS = 'not_addressed';
export const NEEDS_CORRECTION_STATUS = 'needs_correction';

export const PRE_QA_STATUS = {
  [REVIEWED_STATUS]: 'Reviewed',
  [NOT_ADDRESSED_STATUS]: 'Not Addressed',
  [NEEDS_CORRECTION_STATUS]: 'Needs Correction',
};

export interface AlertCounts {
  errorCount: number;
  warningCount: number;
}
